<template>
  <div iv id="alert_modal" class="modal-wrap delivery_address">
    <div class="modal-container">
      <div class="modal_header">
        <div class="header_txt">배송지 관리</div>
      </div>

      <div class="modal_body">
        <div class="modal_contents">
          <table class="bbs_table_1">
            <colgroup>
              <col width="80px" />
              <col width="*" />
              <col width="80px" />
            </colgroup>
            <thead>
              <tr>
                <th>이름</th>
                <th>배송지명</th>
                <th>선택</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>김라온</td>
                <td class="text_left">
                  김라온 | 010-1234-5678<br />
                  도로명: (0000) 서울특별시 영등포구 여의대로 108,<br />
                  파크원타워2 47-48(여의도동)
                </td>
                <td>
                  <div class="ads_btn_area">
                    <div class="btns">선택</div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>김라온</td>
                <td class="text_left">
                  김라온 | 010-1234-5678<br />
                  도로명: (0000) 서울특별시 영등포구 여의대로 108,<br />
                  파크원타워2 47-48(여의도동)
                </td>
                <td>
                  <div class="ads_btn_area">
                    <div class="btns selected">선택</div>
                    <div class="btns delete">삭제</div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="description">
          * 배송지는 최대 5개까지 등록할 수 있습니다.
        </div>
      </div>

      <div class="modal_footer">
        <div class="btn_area">
          <button @click="close" class="btn_basic">닫기</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AddressList',
  components: {
    //
  },
  setup(_, { emit }) {
    const close = () => {
      emit('close')
    }

    return {
      close,
    }
  },
}
</script>

<style></style>
